import React from 'react';
import {
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemIcon,
  Box,
  Divider,
  Typography,
} from '@mui/material';
import {
  Person as PersonIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

export const MenuDerecha = ({ usuario, salirSesion }) => (
  <Box sx={{ width: 280 }}>
    {/* Header del menú */}
    <Box
      sx={{
        p: 3,
        background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
        color: 'white',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar
          src={usuario?.imagenPerfil}
          sx={{
            width: 56,
            height: 56,
            border: '3px solid rgba(255,255,255,0.3)',
          }}
        >
          <PersonIcon />
        </Avatar>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {usuario?.nombrecompleto || 'Usuario'}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, fontSize: '0.875rem' }}>
            {usuario?.email || ''}
          </Typography>
        </Box>
      </Box>
    </Box>

    <Divider />

    {/* Opciones del menú */}
    <List sx={{ py: 1 }}>
      <ListItem
        button
        component={Link}
        to="/perfil"
        sx={{
          py: 1.5,
          px: 3,
          borderRadius: 0,
          '&:hover': {
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40 }}>
          <PersonIcon sx={{ color: 'primary.main' }} />
        </ListItemIcon>
        <ListItemText
          primary="Mi Perfil"
          primaryTypographyProps={{
            sx: {
              fontSize: '0.938rem',
              fontWeight: 600,
              color: 'text.primary',
            },
          }}
        />
      </ListItem>

      <Divider sx={{ my: 1 }} />

      <ListItem
        button
        onClick={salirSesion}
        sx={{
          py: 1.5,
          px: 3,
          borderRadius: 0,
          '&:hover': {
            backgroundColor: 'rgba(211, 47, 47, 0.08)',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40 }}>
          <PowerSettingsNewIcon sx={{ color: 'error.main' }} />
        </ListItemIcon>
        <ListItemText
          primary="Cerrar Sesión"
          primaryTypographyProps={{
            sx: {
              fontSize: '0.938rem',
              fontWeight: 600,
              color: 'error.main',
            },
          }}
        />
      </ListItem>
    </List>
  </Box>
);